module.exports = __webpack_public_path__ + "resources/img/img_watchall_lms1_en.1ca240383f2fe2b92a3beaa5688b8d0a.png";